/* eslint-disable no-console */
import { register } from 'register-service-worker'
import store from './store'

if (process.env.NODE_ENV === 'production') {
  // Reload exactly once when the new SW takes control. iOS Safari can take a
  // while to process SKIP_WAITING, so we wait for controllerchange instead of
  // calling location.reload() manually after postMessage.
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
  });

  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
        console.log(
            'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB [4]'
        )
    },
    registered () {
        console.log('Service worker has been registered. [1]')
    },
    cached () {
        console.log('Content has been cached for offline use. [3]')
    },
    updatefound () {
        console.log('New content is downloading. [2]')
    },
    updated (registration) {
        console.log('New content is available; please refresh.')
        // Show update prompt to user
        store.dispatch('showUpdatePrompt', registration)
    },
    offline () {
        console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
        console.error('Error during service worker registration:', error)
    }
  })
}